import React, { useRef, useEffect, useState } from 'react';
import { Group, Image, Transformer } from 'react-konva';
import useImage from 'use-image';
const MovableImage = React.memo(({ imageIndex, imageData, canvasMultiplier, canvasScaler, currentDraggedIndex, containerRef, updateImageDimensions, isSelected, onSelect, onInteract, imageRef, }) => {
    const uploadedImageRef = useRef(null);
    const transformRef = useRef(null);
    const [canvasImage, setCanvasImage] = useState(null);
    const [placeholderImage] = useImage(imageData.placeholder, 'anonymous');
    const [imageLoaded, setImageLoaded] = useState(false);
    useEffect(() => {
        let attempts = 0;
        const loadImageWithRetry = () => {
            if (attempts >= 3)
                return; // Stop retrying after 3 failed attempts
            console.log(`Attempt ${attempts + 1}: Loading ${imageData.uploadedImage}`);
            const img = new window.Image();
            img.crossOrigin = 'anonymous';
            img.src = imageData.uploadedImage;
            img.onload = () => {
                console.log(`Image Loaded Successfully: ${imageData.uploadedImage}`);
                setCanvasImage(img);
                setImageLoaded(true);
            };
            img.onerror = () => {
                console.error(`Image failed to load (Attempt ${attempts + 1}): ${imageData.uploadedImage}`);
                attempts++;
                setTimeout(loadImageWithRetry, 500); // Retry after 500ms
            };
        };
        if (imageData.uploadedImage) {
            loadImageWithRetry();
        }
    }, [imageData.uploadedImage]);
    useEffect(() => {
        if (transformRef.current && imageLoaded) {
            if (isSelected && uploadedImageRef.current) {
                transformRef.current.nodes([uploadedImageRef.current]);
            }
        }
        else if (imageRef.current) {
            imageRef.current.getLayer().batchDraw();
        }
    }, [imageLoaded, isSelected]);
    if (imageData.loading && placeholderImage != null) {
        return (React.createElement(Image, { image: placeholderImage, width: imageData.position.width * canvasScaler, height: imageData.position.height * canvasScaler, x: imageData.position.pos_x * canvasScaler, y: imageData.position.pos_y * canvasScaler, rotation: imageData.position.rotation }));
    }
    if (!imageLoaded || !canvasImage)
        return null;
    return (React.createElement(Group, { ref: imageRef }, imageData.uploadedImage != null ? (React.createElement(React.Fragment, null,
        React.createElement(Image, { width: imageData.position.width * canvasScaler, height: imageData.position.height * canvasScaler, x: imageData.position.pos_x * canvasScaler, y: imageData.position.pos_y * canvasScaler, rotation: imageData.position.rotation, offsetY: (imageData.position.height * canvasScaler) / 2, offsetX: (imageData.position.width * canvasScaler) / 2, image: canvasImage, ref: uploadedImageRef, onClick: onSelect, onTap: onSelect, draggable: true, fill: "transparent", onDragStart: onInteract, onDragEnd: (e) => {
                const node = uploadedImageRef.current;
                if (node) {
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();
                    node.scaleX(1);
                    node.scaleY(1);
                    const dimensions = {
                        height: Math.max(node.height() * scaleY) * canvasMultiplier,
                        width: Math.max(5, node.width() * scaleX) * canvasMultiplier,
                        pos_x: e.target.x() * canvasMultiplier,
                        pos_y: e.target.y() * canvasMultiplier,
                        rotation: e.target.rotation(),
                    };
                    updateImageDimensions(imageIndex, dimensions);
                    imageRef.current.moveTo(containerRef.current);
                    imageRef.current.zIndex(currentDraggedIndex);
                }
            }, onTransformStart: onInteract, onTransformEnd: (e) => {
                const node = uploadedImageRef.current;
                if (node) {
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();
                    // we will reset it back
                    node.scaleX(1);
                    node.scaleY(1);
                    const newDims = {
                        height: Math.max(node.height() * scaleY) * canvasMultiplier,
                        width: Math.max(5, node.width() * scaleX) * canvasMultiplier,
                        pos_x: node.attrs.x * canvasMultiplier,
                        pos_y: node.attrs.y * canvasMultiplier,
                        rotation: node.rotation(),
                    };
                    updateImageDimensions(imageIndex, newDims);
                }
            } }),
        !!isSelected && (React.createElement(Transformer, { ref: transformRef, flipEnabled: false, rotateEnabled: true, anchorFill: "#F3438C", anchorStroke: "#F3438C", borderStroke: "#DDFC46", borderStrokeWidth: 2, anchorCornerRadius: 8, anchorSize: 16, rotateAnchorOffset: 30, enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'], boundBoxFunc: (oldBox, newBox) => {
                // limit resize
                if (Math.abs(newBox.width) < 5 || Math.abs(newBox.height) < 5) {
                    return oldBox;
                }
                return newBox;
            } })))) : null));
});
export default MovableImage;
